import React from 'react'
import { BsGithub } from "react-icons/bs";
import './GithubLink.css'

export default function GithubLink() {
    return (
        <>
            <div className="github-link"><p>You can checkout the  Github <BsGithub /> repository of this project by clicking on this <a href="https://github.com/BilalAhmed-358/Analysis_of_Algorithms_Project" target='_blank'>Link.</a></p></div>
            
        </>
    )
}
